module.exports = __webpack_public_path__ + "img/triangle.5ef356cd.png";